module.exports = {
  git_sha: '%VERSION_SHA%',
  build_date: '%VERSION_DATE%',
  version_number: '%VERSION_NUMBER%',
};
